module.exports = __webpack_public_path__ + "img/BLS-token-3.3a653459.png";